import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import NewsCompleteAnimation from '@/assets/animation/NewsComplete.json';

type OverviewTopSectionProps = {
  lottieRef: React.RefObject<LottieRefCurrentProps>;
};

export const OverviewTopSection = ({ lottieRef }: OverviewTopSectionProps) => {
  const lottieProps = {
    lottieRef,
    className: 'w-[40px]',
    animationData: NewsCompleteAnimation,
    loop: false,
    autoplay: false,
  };

  return (
    <div className="flex w-full flex-col items-center  gap-[10px] ">
      <Lottie {...lottieProps} />
      <TopAlertText />
    </div>
  );
};

const TopAlertText = () => {
  return (
    <div className="flex flex-col items-center gap-[8px] text-gr-800 Title3S18">
      오늘의 이커머스 소식을 모두 확인했어요!
    </div>
  );
};
